import React from 'react';
import { Building2, Users, Rocket, Award } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen text-white pt-20 md:pt-32">
      {/* Hero Section - Adapté pour mobile */}
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-8 md:mb-16">
          <h1 className="text-3xl md:text-5xl font-bold mb-4 md:mb-6">
  Innover dans la Technologie Financière
  <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#017D7E] to-[#00A99D]">
    Pour les Défis de Demain
  </span>
</h1>

          <p className="text-base md:text-xl text-white/70">
            KG Technologies se distingue comme une fintech en plein essor, dédiée à créer des solutions technologiques de pointe pour transformer le secteur financier, en combinant une profonde compréhension des enjeux métiers et une passion pour l'innovation.
          </p>
        </div>
      </div>

      {/* Key Features - Adapté pour mobile */}
      <div className="bg-white/5 py-12 md:py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 max-w-5xl mx-auto">
            <div className="space-y-6">
              <div className="flex flex-col md:flex-row items-start gap-4">
                <div className="p-2 rounded-lg bg-[#017D7E]/10">
                  <Building2 className="w-6 h-6 text-[#017D7E]" />
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-semibold mb-2">Notre Histoire</h3>
                  <p className="text-sm md:text-base text-white/70">
                    Fondée en 2024, KG Technologies s'est rapidement imposée comme un acteur majeur de la transformation digitale du secteur financier, accompagnant plus de 50 institutions dans leur modernisation.
                  </p>
                </div>
              </div>

              <div className="flex flex-col md:flex-row items-start gap-4">
                <div className="p-2 rounded-lg bg-[#017D7E]/10">
                  <Users className="w-6 h-6 text-[#017D7E]" />
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-semibold mb-2">Notre Équipe</h3>
                  <p className="text-sm md:text-base text-white/70">
                    Plus de 20 experts passionnés répartis dans 8 pays, combinant expertise technologique et connaissance approfondie du secteur financier.
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div className="flex flex-col md:flex-row items-start gap-4">
                <div className="p-2 rounded-lg bg-[#017D7E]/10">
                  <Rocket className="w-6 h-6 text-[#017D7E]" />
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-semibold mb-2">Notre Mission</h3>
                  <p className="text-sm md:text-base text-white/70">
                    Accélérer l'innovation financière en fournissant des solutions technologiques de pointe qui permettent à nos clients de se concentrer sur leur cœur de métier.
                  </p>
                </div>
              </div>

              <div className="flex flex-col md:flex-row items-start gap-4">
                <div className="p-2 rounded-lg bg-[#017D7E]/10">
                  <Award className="w-6 h-6 text-[#017D7E]" />
                </div>
                <div>
                  <h3 className="text-lg md:text-xl font-semibold mb-2">Nos Valeurs</h3>
                  <p className="text-sm md:text-base text-white/70">
                    Excellence technique, innovation continue, engagement client et responsabilité sont au cœur de notre culture d'entreprise.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Statistics - Adapté pour mobile */}
      <div className="py-12 md:py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 max-w-5xl mx-auto">
            <StatCard number="50+" text="Clients Actifs" />
            <StatCard number="20+" text="Experts" />
            <StatCard number="8" text="Pays" />
            <StatCard number="60+" text="Solutions" />
          </div>
        </div>
      </div>
    </div>
  );
};

// Composant StatCard pour les statistiques
const StatCard = ({ number, text }) => (
  <div className="text-center bg-white/5 p-4 md:p-6 rounded-xl border border-white/10">
    <div className="text-2xl md:text-4xl font-bold text-[#017D7E] mb-1 md:mb-2">{number}</div>
    <div className="text-sm md:text-base text-white/70">{text}</div>
  </div>
);

export default About;